<template>
  <div class="container-fluid">
    <PainelAcesso>
      <template #cabecalho >
        <div class="modal-title text-center mt-5" >
          <div class="d-flex justify-content-center ">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12">
              <h5 class="textos text-center text-bold">
                Acesso bloqueado
              </h5>
              <h6 class="text-center">
                <span class="textos">O acesso ao sistema foi bloqueado devido a pagamento pendente.</span><br />
                <span class="textos">O pagamento deverá ser efetuado para continuar o uso do sistema.</span>
              </h6>
            </div>
          </div>
        </div>
      </template>
      <template #corpo>
        <form class="mt-4 ">
          <div class="d-flex justify-content-center">
            <b-button  variant="btn btn-cinza" :disabled="flagsDeControle.manipulandoDados.status" @click="logout()">Sair</b-button>
            <div class="ml-1"></div>
            <b-button v-if="representanteLegal" variant="btn btn-verde" :disabled="flagsDeControle.manipulandoDados.status" @click="redirecionarParaPagamento()">Acessar faturas</b-button>
          </div>
        </form>
      </template>
    </PainelAcesso>
  </div>
</template>

<script>
import PagamentoPendente from './js/pagamentoPendente'
export default PagamentoPendente
</script>

<style scoped>
@import "./scss/login.scss";
</style>
